import { HERO_PRODUCTS, type HeroProduct } from "@marketing/site";

/**
 * Where the floating product cards sit around the phone, as fractions of the stage (0,0 top
 * left). The flat cards of the first paint and the 3D cards use the same spots, so the switch
 * from one to the other does not move anything. `depth` pushes a card back (smaller, slower
 * parallax); `wide` cards are hidden on narrow screens where they would cover the phone.
 */
export interface CardSpot {
	product: HeroProduct;
	x: number;
	y: number;
	depth: number;
	tilt: number;
	wide?: boolean;
}

const P = HERO_PRODUCTS;

export const CARD_SPOTS: CardSpot[] = [
	// Two loose columns beside the phone. The 3D canvas reaches past the stage (CANVAS_BLEED) so
	// a card near the edge can lean and drift without being cut off.
	{ product: P.milk, x: 0.2, y: 0.16, depth: 0.1, tilt: -9 },
	{ product: P.eggs, x: 0.1, y: 0.4, depth: 0.4, tilt: 6, wide: true },
	{ product: P.pita, x: 0.21, y: 0.63, depth: 0.15, tilt: 8 },
	{ product: P.garlic, x: 0.11, y: 0.86, depth: 0.45, tilt: -5, wide: true },
	{ product: P.doritos, x: 0.8, y: 0.14, depth: 0.2, tilt: 9 },
	{ product: P.cola, x: 0.9, y: 0.38, depth: 0.05, tilt: -7, wide: true },
	{ product: P.cashews, x: 0.79, y: 0.62, depth: 0.3, tilt: -9 },
	{ product: P.chicken, x: 0.89, y: 0.85, depth: 0.5, tilt: 5, wide: true },
];

/**
 * How far the 3D canvas reaches past the stage on every side, as a share of the stage. A card
 * near the edge leans and drifts with the pointer: without the margin the canvas cut it off.
 */
export const CANVAS_BLEED = 0.15;

/**
 * Where the phone's three product cards are, in pixels from the phone's centre (the phone is
 * 318 × 652 at full size and the stage centres it): the cards' landing spots.
 */
export const LANDING = [
	{ dx: -96, dy: 122 },
	{ dx: 0, dy: 122 },
	{ dx: 96, dy: 122 },
];

/** On a recipe card the products land on its rows' thumbnails, one under the other. */
export const RECIPE_LANDING = [
	{ dx: -108, dy: 17 },
	{ dx: -108, dy: 61 },
	{ dx: -108, dy: 105 },
];
